import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { CATEGORIES, COMPANY, STATS } from '../../mock';
import { categoryPath } from '../../api';

export default function CategoryGateway() {
  return (
    <section className="pt-28 md:pt-32 pb-16 md:pb-24 bg-white">
      <div className="egea-container">
        <div className="max-w-[780px] egea-rise">
          <span className="section-eyebrow">{COMPANY.tagline}</span>
          <h1 className="font-display font-black uppercase tracking-tight text-slate-900 text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-4">
            Alege categoria<br />
            <span className="text-[#f5a524]">potrivită</span> proiectului tău
          </h1>
          <p className="mt-5 text-base md:text-lg text-slate-600 max-w-[560px] leading-relaxed">
            Producător român de confecții metalice din 1995. Selectează o categorie pentru a vedea
            produsele și a cere o ofertă tehnică.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6 mt-12" data-testid="category-gateway">
          {CATEGORIES.map((c, i) => (
            <Link
              key={c.key}
              to={categoryPath(c.key)}
              data-testid={`gateway-card-${i}`}
              className="group relative overflow-hidden border border-slate-200 bg-slate-900 min-h-[360px] md:min-h-[460px] flex flex-col justify-end p-7 transition-all duration-300 hover:shadow-2xl"
            >
              <img
                src={c.image}
                alt={c.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/45 to-transparent" />
              <div className="relative z-10">
                <span className="inline-block text-[11px] font-bold uppercase tracking-[0.25em] text-[#f5a524] mb-3">
                  0{i + 1} / Categorie
                </span>
                <h2 className="font-display font-bold uppercase text-white text-2xl md:text-3xl leading-tight">
                  {c.title}
                </h2>
                <p className="text-sm text-slate-200 mt-2.5 max-w-[300px] leading-relaxed">{c.subtitle}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-white group-hover:gap-3.5 transition-all">
                  Vezi produse <ArrowUpRight size={18} className="text-[#f5a524]" />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 border-t border-slate-200 pt-10">
          {STATS.map((s) => (
            <div key={s.label} className="border-l-2 border-[#f5a524] pl-4">
              <div className="font-display font-black text-slate-900 text-3xl md:text-4xl leading-none">{s.value}</div>
              <div className="text-sm text-slate-500 mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
